export default "__VITE_PUBLIC_ASSET__67f4d4a6__"